import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import {styled} from '@mui/material/styles';
import ClinetActions from './ClinetActions';

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  '&:first-of-type': {
    paddingLeft: 20,
  },
  '&:last-of-type': {
    paddingRight: 20,
  },
  width: 100,
  maxWidth: 100,
  overflow: 'hidden',
}));
const TableItem = ({data, deleteCustomer, domainMapping = {}}) => {
  const renderCellValue = (key, value) => {
    // Hide api_key column
    if (key === 'api_key') {
      return null;
    }
    
    // Show domain name instead of domain_id
    if (key === 'domain_id') {
      return domainMapping[value] || value;
    }
    
    // Convert deleted from 0/1 to No/Yes
    if (key === 'deleted') {
      return value === 1 ? 'Yes' : 'No';
    }
    
    // Handle other values
    if (value === null || value === undefined) {
      return '';
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return value;
  };

  // Filter out api_key column
  const filteredKeys = Object.keys(data).filter(key => key !== 'api_key');

  return (
    <TableRow key={data.id} className='item-hover'>
      {filteredKeys.map((key) => {
        const cellValue = renderCellValue(key, data[key]);
        if (cellValue === null) return null; // Skip hidden columns
        
        return (
          <StyledTableCell key={data.id + key + ''} align='left' width={1}>
            {cellValue}
          </StyledTableCell>
        );
      })}
      <StyledTableCell align='right'>
        <ClinetActions customerId={data.id} deleteCustomer={deleteCustomer} />
      </StyledTableCell>
    </TableRow>
  );
};

export default TableItem;

TableItem.propTypes = {
  data: PropTypes.object.isRequired,
  deleteCustomer: PropTypes.func.isRequired,
  domainMapping: PropTypes.object,
};
